/** Keep in sync with context STORAGE_KEY. */
const STORAGE_KEY = "semanticad.locale";

/** Sync <html lang> so CSS text-transform: uppercase uses the correct alphabet. */
export function applyDocumentLang(locale?: "en" | "tr"): void {
  if (typeof document === "undefined") return;
  let loc: "en" | "tr" = locale ?? "en";
  if (locale == null) {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      loc = raw === "tr" ? "tr" : "en";
    } catch {
      loc = "en";
    }
  }
  document.documentElement.lang = loc === "tr" ? "tr" : "en";
}
